import type { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '../../template/IconTemplateIPortIcon'
import { CustomIconProps } from '../../types/types'

export const SvgStars = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon {...props}>
			<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M24.0016 4L29.8795 15.9098L43.0227 17.8197C43.0227 17.8197 35.1149 22.1573 33.5122 27.0902C31.9094 32.023 35.7573 40.1803 35.7573 40.1803L24.0016 34L12.2459 40.1803L14.491 27.0902L4.98047 17.8197C4.98047 17.8197 13.9276 18.9585 18.1237 15.9098C22.3199 12.8612 24.0016 4 24.0016 4Z"
					fill="#4A4A4A"
				/>
				<path
					d="M24.0016 15.9098V4L18.1237 15.9098L4.98047 17.8197L14.491 27.0902L12.2459 40.1803L24.0016 34V15.9098Z"
					fill="url(#paint0_linear_13561_60281)"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_13561_60281"
						x1="32.0016"
						y1="38"
						x2="5.00159"
						y2="18"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#E4EDFC" />
						<stop offset="1" stopColor="#568DFE" />
					</linearGradient>
				</defs>
			</svg>
		</IconTemplateIPortIcon>
	)
}
